import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
import { msSessionStorage } from '@common/utils/cache';
import { getCookie } from '@common/stores/cookie';
import { AES } from '@common/utils/common';
import { IAyhPublicData } from '@common/typings/global';
import { customHeaderConfig } from './header';
import { TIMEOUT } from '@common/error/constants';

interface AxiosRequestConfigSelf extends AxiosRequestConfig {
  encryStr?: string;
  encrysktrans?: string;
}

const config: AxiosRequestConfigSelf = {
  encryStr: '',
  encrysktrans: '',
  timeout: TIMEOUT,
};

const $axios = axios.create(config);

//添加请求拦截器
$axios.interceptors.request.use(
  function (config: AxiosRequestConfigSelf) {
    const AYH_PUBLIC_DATA = window.AYH_PUBLIC_DATA || {};
    // 默认headers
    const headers = {
      'content-type': 'application/json;charset=UTF-8',
      ...customHeaderConfig(config.headers['X-Application-Id'] || 'syhdl'),
    };

    // 需要整体加密的参数
    // const encodeUrl = [
    // '/withdraw/vayh/cash/V1.0/amortization/calculate',
    // 'vayh/apply/V1.0/shuntAuth',
    // 'vayh/sms/V1.0/binding',
    // 'vayh/sms/V1.0/smscode',
    // '/pay/quickPaySms/V1/create',
    // '/pay/wapOrder/V1/submit',
    // 'vayh/pwd/V1.0/trade/reset',
    // '/vayh/my/V1.0/aes/profileforhidden',
    // '/vayhapi/vayh/my/V1.0/aes/profileforhidden',
    // '/vayh/bank/V1.0/aes/bankCardNumberOCR',
    // '/vayh/bank/V1.0/aes/bankCardNumberOCR',
    // '/withdraw/vayh/cash/V1.0/submitCashApply',
    // ];

    const miniProgramUrl = ['/services/ayh/adGroupsInfo'];

    const adReachUrl = ['/vayh/inner/V1.0/vayhapiconfig'];

    if (config?.url) {
      config.headers['msgId'] = window.afMsgId || '';
      config.headers['X-AfMsgId'] = window.afMsgId || '';

      // 小程序scheme中转页单独设置X-Application-Id
      if (miniProgramUrl.includes(config.url) && config.data.terminalCode === 'AYHXCX') {
        config.headers['X-Application-Id'] = 'MS_XCX_AYH';
      }

      // 查询vayhapi分流配置
      if (adReachUrl.includes(config.url)) {
        config.headers['X-Application-Id'] = 'SYH_IOS';
      }

      if (config.headers['MS-ENCODE-PATH']) {
        const decryptData = AES.wholeEncryParams(config);
        // 整体加密
        config.data = { decryptData };
        config.headers['X-Decrypt-Data'] = config.encrysktrans || '';
        config.headers['X-Sk-Trans'] = config.encrysktrans || '';
        config.headers['X-EncryKey-V'] = 'SYS_COMMWEB_V2';
        delete config.headers['MS-ENCODE-PATH'];
      }
    }

    config.headers['afclientinfo'] =
      JSON.stringify(msSessionStorage.get('PUBLIC_AFCLIENTINFO')) || '';
    config.headers['client-time'] = Date.now();
    config.headers['client'] = 'ms-loan';

    // todo: token 逻辑放到 request
    // const token = getQueryString('vtoken') || getCookie('vtoken');
    // if (token !== undefined && token !== null && token !== 'undefined' && token !== 'null') {
    //   config.headers['X-VToken'] = token;
    // }

    config.headers['sensorsanonymousid'] = window.sensorsAnonyMousId || '';

    if (AYH_PUBLIC_DATA._aesEncryTime) {
      config.headers['X-AesLocal-Time'] = AYH_PUBLIC_DATA._aesEncryTime;
    }
    // 请求key新增page信息：
    config.headers['X-Page'] = 'cashPage';

    // 灰度：
    config.headers['X-Label'] = getCookie('inlinegray') || '';

    if (AYH_PUBLIC_DATA._aesEncryTime) {
      config.headers['X-AesLocal-Time'] = AYH_PUBLIC_DATA._aesEncryTime;
    }

    if (config?.data?._encrysktrans) {
      config.headers['sktrans'] = AYH_PUBLIC_DATA._encrysktrans;
    }
    config.headers = Object.assign(headers, config.headers);
    return config;
  },
  function (error) {
    //请求错误时做些事
    return Promise.reject(error);
  },
);

// 添加响应拦截器
$axios.interceptors.response.use(
  function (response) {
    const config = (response?.config ?? {}) as AxiosRequestConfigSelf;
    // 灰度
    if (response.headers['X-Label']) {
      config.headers['X-Label'] = response.headers['X-Label'];
    }
    //对响应数据做些事
    if (!window.AYH_PUBLIC_DATA) {
      window.AYH_PUBLIC_DATA = {} as IAyhPublicData;
    }
    window.AYH_PUBLIC_DATA._sktrans = config.encryStr || '';
    if (response?.data?.decryptData) {
      window.AYH_PUBLIC_DATA._sktrans = config.encryStr || '';
      // TODO: 加密解密先不处理
      response.data.result = JSON.parse(
        AES.wholeAesDecip(response.data.decryptData, config.encryStr) || '{}',
      );
    }
    return response;
  },
  function (error) {
    //请求错误时做些事
    return Promise.reject(error);
  },
);

export default $axios;
